import MyContext from "../../../contexts/MyContext";
import { TicketForm5 } from "../ticket-forms/TicketForm5";

export const Slide5 = (props) => {
  return <MyContext.Consumer>{(context) => <div hidden={context.activeSlide !== 4}>{<TicketForm5 {...props} />}</div>}</MyContext.Consumer>;
};
